import { Navigate, useLocation } from 'react-router-dom';
import { APICore } from '../helpers/api/apiCore';


const PrivateRoute = ({ component: RouteComponent, roles }) => {
    let location = useLocation();
    const api = new APICore();
    const loggedInUser = api.getLoggedInUser();
    /**
     * not logged in so redirect to login page with the return url
     */
    if (api.isUserAuthenticated() === false) {
        return <Navigate to={'/login'} state={{ from: location }} replace />;
    }

    // check if route is restricted by role
    if (roles && roles.indexOf(loggedInUser.role) === -1) {
        // role not authorised so redirect to home page
        return <Navigate to={{ pathname: '/login' }} />;
    }

    return (<>
        <RouteComponent />
    </>);
};

export default PrivateRoute;